import {
  Link,
  Links,
  LiveReload,
  Meta,
  NavLink,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import React from "react";

import TrayMenu from "./tray-menu.tsx";
import HeaderAccount from "./header-account.tsx";

export default function SiteHeader(props: { simple?: boolean; ident?: any; requestUrl?: string }) {
  const hideJoin = !!props.requestUrl && (props.requestUrl.includes("/petition/account") ||
    props.requestUrl.includes("/membership/account"));
  const isContribute = props.requestUrl?.includes("/contribute");

  return (
    <header id="masthead" className={`SiteHeader ${isContribute ? "--beige" : ""}`} role="banner">
      <div className="SiteHeader__Inner">
        <div className="SiteHeader__Left">
          {props.simple ? null : <TrayMenu />}
          <div className="SiteHeader__Logo">
            <a href="https://talkingpointsmemo.com" rel="home" className="">
              <img
                src="https://talkingpointsmemo.com/wp-content/themes/talkingpointsmemo/assets/images/logo/TPM-logo.svg"
                alt="Talking Points Memo Logo"
              />
            </a>
          </div>
        </div>
        <div className="SiteHeader__Right">
          {!props.simple && (
            <HeaderAccount
              ident={props.ident}
              hideJoin={hideJoin}
              showSignIn={isContribute}
            />
          )}
        </div>
      </div>
    </header>
  );
}
